/**
 * doneForYouData
 *
 * Shared content for the Done For You service page (in-app and landing).
 */
export const doneForYouFeatures = [
  {
    iconName: "CheckCircle",
    title: "Custom Creative",
    description: "Tailored designs aligned with your messaging, brand, and campaign objectives.",
    items: [
      "Brand-aligned designs",
      "Strategic messaging",
      "Multi-platform assets"
    ]
  },
  {
    iconName: "Users",
    title: "Expert Team",
    description: "Our political creative specialists handle everything from concept to final assets.",
    items: [
      "Political design experts",
      "Copy and messaging pros",
      "Campaign strategists"
    ]
  },
  {
    iconName: "FileCheck",
    title: "Full-Service",
    description: "From strategy to final assets, we handle every aspect of your campaign creative.",
    items: [
      "Strategic planning",
      "Design and production",
      "Campaign rollout"
    ]
  },
  {
    iconName: "TrendingUp",
    title: "Data-Driven",
    description: "We apply insights from thousands of successful political campaigns to your content.",
    items: [
      "Performance analysis",
      "Proven creative approaches",
      "Audience targeting insights"
    ]
  }
];

/**
 * Calendly scheduling URL for the consultation booking link
 */
import { kevinMeetingUrl } from '../scheduling/schedulingLinks';

export const calendlySchedulingUrl = kevinMeetingUrl;

/**
 * Form field configuration
 */
export const formFields = {
  firstName: {
    id: "firstName",
    name: "firstName", 
    label: "First name",
    placeholder: "Your first name",
    autoComplete: "given-name",
    required: true
  },
  lastName: {
    id: "lastName",
    name: "lastName",
    label: "Last name", 
    placeholder: "Your last name",
    autoComplete: "family-name",
    required: true
  },
  email: {
    id: "email",
    name: "email",
    label: "Email",
    placeholder: "your.email@example.com", 
    autoComplete: "email",
    required: true,
    type: "email"
  },
  message: {
    id: "message",
    name: "message",
    label: "Tell us about your campaign",
    placeholder: "Share details about your campaign needs, timeline, and goals.",
    required: true,
    rows: 4
  }
};

/**
 * Page text content
 */
export const pageContent = {
  title: "Done For You",
  subtitle: "Get professional services from our team of experts who will handle your campaign creation from start to finish.",
  featuresTitle: "Our Professional Services",
  getStartedTitle: "Get Started",
  getStartedSubtitle: "Reach out to our team to discuss your campaign needs or schedule a consultation call.",
  contactTabLabel: "Contact Us",
  scheduleTabLabel: "Schedule a Call",
  scheduleText: "Schedule a 30-minute consultation with our creative team to discuss your needs and how we can help.",
  scheduleButtonText: "Schedule Now",
  submitButtonText: "Send Message",
  submittingButtonText: "Sending...",
  successMessage: "Thanks! We'll be in touch soon to discuss your custom campaign."
};

export default {
  doneForYouFeatures,
  calendlySchedulingUrl,
  formFields,
  pageContent
}; 